import { gatewayFetcher } from './gatewayFetcher';

export const getMunicipiosByEstado = async estado => {
  const { data } = await gatewayFetcher.get('/municipalities', {
    params: { estado },
  });
  return data;
};

export const registerCampaign = async payload => {
  const { data } = await gatewayFetcher.post(
    '/campaign-registration/register',
    payload,
  );
  return data;
};

export const getNearestCity = async ({ latitude, longitude }) => {
  const { data } = await gatewayFetcher.get(
    '/campaign-registration/nearest-city',
    {
      params: { latitude, longitude },
    },
  );
  return data;
};

export const getCities = async () => {
  const { data } = await gatewayFetcher.get('/campaign-registration/cities');

  return data.data;
};

export const createCity = async payload => {
  const { data } = await gatewayFetcher.post(
    '/campaign-registration/cities',
    payload,
  );
  return data.data;
};

export const getDifusionChannels = async () => {
  const { data } = await gatewayFetcher.get(
    '/campaign-registration/difusion-channels',
  );
  return data.data;
};
